/* eslint-disable */
import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/bus-fare-types/";


const state = {
    busFareTypes: []
}

const actions = {
    async retrieveBusFareTypes({
        commit,
        dispatch
    }, payload) {
        // retrieve bus fare types list from bus application database        
        return axios
            .get(
                baseUrl
            )
            .then(response => {
                commit('SET_BUS_FARE_TYPES', response.data)
                return response.data
            })
    },
    async createBusFareType({
        commit, dispatch
    }, payload) {
        await axios
            .post(baseUrl, payload.payload)
            .then( response => {
                dispatch('retrieveBusFareTypes')
                return response.data
            })
    },
    async updateBusFareType({
        commit, dispatch
    }, payload) {
        await axios
            .patch(baseUrl + payload.item_id + '/', payload.payload)
            .then( response =>  {
                dispatch('retrieveBusFareTypes')
                return response.data
            })
    },
    async deleteBusFareType({
        commit, dispatch
    }, payload) {
        return axios.delete(baseUrl + payload.item_id + '/')
    }
}

const mutations = {
    SET_BUS_FARE_TYPES(state, bus_fare_types) {
        state.busFareTypes = bus_fare_types
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}